/* eslint-disable react/prop-types */
import React from "react";
import { Doughnut } from "react-chartjs-2";
import CustomTooltip from "app/common/chart/CustomTooltipComponent";
import { nFormatter } from "lib/utils";

function AggregateDoughnutComponent({ data }) {
  const refs = React.useRef();
  const [tooltipProps, setTooltipProps] = React.useState({});
  const setPositionAndData = (payload) => {
    setTooltipProps({
      top: payload.top,
      left: payload.left,
      position: "fixed",
      tooltipModel: payload.tooltipModel,
      showTooltip: true,
    });
  };

  const hide = () => {
    setTooltipProps({
      ...tooltipProps,
      showTooltip: false,
    });
  };

  const chartOptions = {
    layout: {
      padding: {
        left: 10,
        right: 10,
        top: 10,
        bottom: 10,
      },
    },
    legend: {
      display: false,
    },
    tooltips: {
      enabled: false,
      intersect: true,
      mode: "point",
      custom: React.useCallback((tooltipModel) => {
        if (tooltipModel.opacity === 0) {
          hide();
          return;
        }

        const chart = refs.current.chartInstance;
        const { canvas } = chart.ctx;

        if (canvas) {
          const position = canvas.getBoundingClientRect();

          // set position of tooltip
          const left = position.left + tooltipModel.caretX;
          const top = position.top + tooltipModel.caretY;

          setPositionAndData({ top, left, tooltipModel });
        }
      }, []),
    },
    cutoutPercentage: "60",
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <>
      {tooltipProps.showTooltip ? (
        <CustomTooltip
          tooltipProps={tooltipProps}
          tooltipData={{
            title: `${
              refs.current.chartInstance.data.labels[
                tooltipProps.tooltipModel.dataPoints[0].index
              ]
            }`,
            subtitle: `${
              refs.current.chartInstance.data.datasets[
                tooltipProps.tooltipModel.dataPoints[0].datasetIndex
              ].data[tooltipProps.tooltipModel.dataPoints[0].index] === null
                ? "N/A"
                : nFormatter(
                    refs.current.chartInstance.data.datasets[
                      tooltipProps.tooltipModel.dataPoints[0].datasetIndex
                    ].data[tooltipProps.tooltipModel.dataPoints[0].index]
                  )
            }`,
            borderStyle: {
              borderColor:
                refs.current.chartInstance.data.datasets[
                  tooltipProps.tooltipModel.dataPoints[0].datasetIndex
                ].backgroundColor[
                  tooltipProps.tooltipModel.dataPoints[0].index
                ],
            },
          }}
        />
      ) : null}
      <Doughnut ref={refs} data={data} options={chartOptions} />
    </>
  );
}

export default AggregateDoughnutComponent;
